'use strict'

import newsletterModal from 'Modules/newsletterModal'
/**
 * Ajoute une classe aux éléments animés (bouton de taille, etc)
 */

$('.check-animated').on('click', function () {
    $(this).toggleClass('draw')
})

/**
 * GESTION ERREURS
 */

// ERREUR JS
window.onerror = function (message, url, lineNumber, colno, error) {
    sendError(message, url, lineNumber, colno, error)
}

// ERREUR VUE JS
Vue.config.errorHandler = function (err, vm, info) {
    const message = JSON.stringify({
        stack: err.stack,
        info
    })

    sendError(message, '', 0, 0)
}

function sendError(message, url, lineNumber, colno, error = {}) {
    if (message.namespace || message.includes('Script error.')) {
        return
    }

    const data = {
        message: message,
        url: url,
        lineNumber: lineNumber,
        colno: colno,
        error: JSON.stringify(error)
    }

    console.error(message)

    $.ajax({
        type: 'POST',
        url: '/layout/logjserror',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
    }).done(function () {})
}

window.showLoader = function () {
    $('body').css('overflow', 'hidden')
    $('.container__loaderSpinner').removeClass('hide')
}
window.hideLoader = function () {
    $('body').css('overflow', 'auto')
    $('.container__loaderSpinner').addClass('hide')
}

//Rend la méthode ouvrirModalNewsletter(modal qui collecte les mails) accessible globalement
window.ouvrirModalNewsletter = newsletterModal.ouvrirModalNewsletter

/**
 * Initialise le déclencheur du modal newsletter sur le banner
 * Ajoute un event listener de clic si l'élément existe
 */
function checkModalNewsletter() {
    if (!document.querySelector('#modal-newsletter-headBanner')) return

    document
        .querySelector('#modal-newsletter-headBanner')
        .addEventListener('click', function () {
            ouvrirModalNewsletter()
        })
}
checkModalNewsletter()
